// @tabler/icons-react
import {
  IconHome,
  IconDatabase,
  IconRefresh,
  IconUser,
  IconBuilding,
  IconMail,
  IconHexagon,
  IconPackage,
  IconChartBar,
  IconSend,
  IconDeviceMobile,
  IconActivity,
  IconArrowsLeftRight,
  IconShield,
  IconWallet,
  IconTool,
  IconRadio,
  IconTicket,
  IconShoppingBag,
  IconClipboardList,
  IconFileText,
  IconReceipt,
  IconWifi,
  IconClock,
  IconTrendingDown
} from '@tabler/icons-react';

export interface NavigationSubChild {
  name: string;
  href: string;
  pageKey: string;
}

export interface NavigationChild {
  name: string;
  href?: string;
  pageKey: string;
  icon?: never;
  children?: NavigationSubChild[];
}

export interface NavigationItem {
  name: string;
  href?: string;
  icon?: React.ComponentType<any>;
  pageKey: string;
  children?: NavigationChild[];
}

export const navigation: NavigationItem[] = [
  { name: 'AI Data Assistant', href: '/ai-sql', icon: IconDatabase, pageKey: 'ai-sql' },
  {
    name: 'Churn',
    icon: IconTrendingDown,
    pageKey: 'churn',
    children: [
      { name: 'Churn Candidates', href: '/churn/candidates', pageKey: 'churn' },
      { name: 'Failed Executions', href: '/churn/failed-executions', pageKey: 'churn' },
    ],
  },
  {
    name: 'Campaigns',
    icon: IconSend,
    pageKey: 'campaigns',
    children: [
      { name: 'Campaign Stats', href: '/campaigns/stats', pageKey: 'campaigns' },
      { name: 'Send Jobs', href: '/campaigns/jobs', pageKey: 'campaigns' },
      { name: 'Scheduled Campaigns', href: '/campaigns/scheduled', pageKey: 'campaigns' },
      { name: 'Test Recipients', href: '/campaigns/test-recipients', pageKey: 'campaigns' },
      { name: 'Direct Send', href: '/campaigns/direct-send', pageKey: 'campaigns' },
      { name: 'Targeting Rules', href: '/campaigns', pageKey: 'campaigns' },
    ],
  },
  {
    name: 'Compliance',
    icon: IconBuilding,
    pageKey: 'entities',
    children: [
      { name: 'Entities', href: '/compliance/entities', pageKey: 'entities' },
      { name: 'People', href: '/compliance/people', pageKey: 'people' },
    ],
  },
  { name: 'Customers', href: '/customers', icon: IconUser, pageKey: 'customers' },
  { name: 'Cycle', href: '/cycle/agent-sync', icon: IconRefresh, pageKey: 'cycle' },
  { name: 'Dashboard', href: '/dashboard', icon: IconHome, pageKey: 'dashboard' },
  {
    name: 'Dev Tools',
    icon: IconTool,
    pageKey: 'dev-tools',
    children: [
      { name: 'Column to CSV', href: '/dev-tools/column-to-csv', pageKey: 'dev-tools' },
      { name: 'CSV to JSON', href: '/dev-tools/csv-to-json', pageKey: 'dev-tools' },
    ],
  },
  {
    name: 'Distributors',
    icon: IconBuilding,
    pageKey: 'distributors',
    children: [
      { name: 'Distributor Management', href: '/distributors', pageKey: 'distributors' },
    ],
  },
  { name: 'Email History', href: '/email-history', icon: IconMail, pageKey: 'email-history' },
  { name: 'Honey Connect Agent', href: '/honey-connect', icon: IconHexagon, pageKey: 'honey-connect' },
  { name: 'IoT', href: '/iot', icon: IconWifi, pageKey: 'iot' },
  { name: 'Jobs', href: '/jobs', icon: IconClock, pageKey: 'jobs' },
  {
    name: 'Monitoring',
    icon: IconActivity,
    pageKey: 'monitoring',
    children: [
      { name: 'DMA Monitor', href: '/monitoring/dma-monitor', pageKey: 'monitoring' },
      { name: 'EasyCron', href: '/monitoring/easycron', pageKey: 'monitoring' },
      { name: 'Pub/Sub', href: '/monitoring/pubsub', pageKey: 'monitoring' },
      { name: 'Site24x7', href: '/monitoring/site24x7', pageKey: 'monitoring' },
    ],
  },
  {
    name: 'MTN',
    icon: IconRadio,
    pageKey: 'mtn',
    children: [
      { name: 'Billing Recon', href: '/mtn/billing-recon', pageKey: 'mtn' },
      { name: 'Invoices', href: '/mtn/invoices', pageKey: 'mtn' },
    ],
  },
  { name: 'Products', href: '/products', icon: IconPackage, pageKey: 'products' },
  {
    name: 'Promo Data',
    icon: IconChartBar,
    pageKey: 'promo-data',
    children: [
      { name: 'Rewards Engine', href: '/promo-data/rewards-engine', pageKey: 'promo-data' },
    ],
  },
  {
    name: 'Reports',
    icon: IconFileText,
    pageKey: 'reports',
    children: [
      { name: 'SPAR Mobile Expo Report', href: '/reports/spar-mobile-expo', pageKey: 'reports' },
    ],
  },
  {
    name: 'Shopify',
    icon: IconShoppingBag,
    pageKey: 'shopify',
    children: [
      { name: 'Monthly Billing', href: '/shopify/monthly-billing', pageKey: 'shopify' },
      { name: 'Stock Management', href: '/shopify/stock-management', pageKey: 'shopify' },
    ],
  },
  {
    name: 'SIM Cards',
    icon: IconDeviceMobile,
    pageKey: 'sim-cards',
    children: [
      { name: 'Assign eSIMs', href: '/sim-cards/assign-esims', pageKey: 'assign-esims' },
      { name: 'Innerbox Management', href: '/sim-cards/innerbox', pageKey: 'innerbox' },
      { name: 'SIM Card Import', href: '/sim-cards/sim-import', pageKey: 'sim-import' },
      { name: 'SIM Stock', href: '/sim-cards/sim-stock', pageKey: 'sim-stock' },
    ],
  },
  { 
    name: 'SPAR Mobile', 
    icon: IconChartBar, 
    pageKey: 'spar-mobile',
    children: [
      { name: 'Abuse Detection Reports', href: '/spar-mobile/abuse-detection-reports', pageKey: 'spar-mobile' },
      { name: 'Basket Search', href: '/spar-mobile/basket-search', pageKey: 'spar-mobile' },
      { name: 'Brevo Contacts Sync', href: '/spar-mobile/brevo-contacts-sync', pageKey: 'spar-mobile' },
      { name: 'Expired Rewards', href: '/spar-mobile/expired-rewards', pageKey: 'spar-mobile' },
      { name: 'Incentive Reconciliation', href: '/spar-mobile/incentive-reconciliation', pageKey: 'spar-mobile' },
      {
        name: 'Promo Data Attribution',
        pageKey: 'spar-mobile',
        children: [
          { name: 'Executive Summary', href: '/spar-mobile/promo-attribution/executive-summary', pageKey: 'spar-mobile' },
          { name: 'Overview', href: '/spar-mobile/promo-attribution', pageKey: 'spar-mobile' },
          { name: 'Products', href: '/spar-mobile/promo-attribution/products', pageKey: 'spar-mobile' },
          { name: 'Rules', href: '/spar-mobile/promo-attribution/rules', pageKey: 'spar-mobile' },
          { name: 'Methodology', href: '/spar-mobile/promo-attribution/methodology', pageKey: 'spar-mobile' },
        ],
      },
      { name: 'Retailer Commissions', href: '/spar-mobile/retailer-commissions', pageKey: 'spar-mobile' },
      { name: 'SPAR Rewards', href: '/spar-mobile/spar-rewards', pageKey: 'spar-mobile' },
      { name: 'Store Compliance', href: '/spar-mobile/store-compliance', pageKey: 'spar-mobile' },
      { name: 'ROM Management', href: '/spar-mobile/rom-management', pageKey: 'spar-mobile' },
      { name: 'Store Ownership Change', href: '/spar-mobile/store-ownership-change', pageKey: 'spar-mobile' },
      { name: 'Transfer Promo Data', href: '/spar-mobile/transfer-promo-data', pageKey: 'spar-mobile' },
      { name: 'Voucher Matching', href: '/spar-mobile/voucher-matching', pageKey: 'spar-mobile' },
    ]
  },
  { name: 'Surveys', href: '/surveys', icon: IconClipboardList, pageKey: 'surveys' },
  { name: 'Transactions', href: '/transactions', icon: IconArrowsLeftRight, pageKey: 'transactions' },
  {
    name: 'User Management',
    icon: IconShield,
    pageKey: 'user-management',
    children: [
      { name: 'Role Permissions', href: '/role-permissions', pageKey: 'user-management' },
      { name: 'Users', href: '/user-management', pageKey: 'user-management' },
    ],
  },
  {
    name: 'Vouchers',
    icon: IconTicket,
    pageKey: 'vouchers',
    children: [
      { name: 'OTT Voucher', href: '/vouchers/ott-voucher', pageKey: 'vouchers' },
    ],
  },
  {
    name: 'Wallet',
    icon: IconWallet,
    pageKey: 'wallet',
    children: [
      { name: 'Merchant Accounts', href: '/wallet/merchant-accounts', pageKey: 'wallet' },
      { name: 'Wallet Failures', href: '/wallet-failures', pageKey: 'wallet' },
      { name: 'Wallet Query', href: '/wallet', pageKey: 'wallet' },
    ],
  },
  {
    name: 'Xero',
    icon: IconReceipt,
    pageKey: 'xero',
    children: [
      { name: 'Contacts', href: '/xero/contacts', pageKey: 'xero' },
      { name: 'Statements', href: '/xero/statements', pageKey: 'xero' },
    ],
  },
];
